import { IPreloadedState } from 'shared/types/redux';

export const selectGeoTags = (state: IPreloadedState) => state.tags.meta.geoTags;
